var map = {
	"./android/detection": 960,
	"./androidtv/detection": 961,
	"./arris/detection": 962,
	"./hisense/detection": 963,
	"./lg/detection": 964,
	"./nagra/detection": 965,
	"./netrange/detection": 966,
	"./opera/detection": 967,
	"./polaroid/detection": 968,
	"./ps4/detection": 969,
	"./samsung/detection": 970,
	"./seirobotics/detection": 971,
	"./sony/detection": 972,
	"./stbcoship/detection": 973,
	"./stbcoship9108/detection": 974,
	"./stbhuawei/detection": 975,
	"./stbkaon/detection": 976,
	"./tizen/detection": 977,
	"./web0s/detection": 978,
	"./workstation/detection": 979,
	"./workstationChafari/detection": 980,
	"./zeasn/detection": 981,
	"./zte/detection": 982
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/detection$
// module id = 959
// module chunks = 0